import React from "react";
import { Box } from "@origin-digital/ods-core";
import { SearchResultItem } from "./SearchResultItem";
import type { ISearchResultDto } from "../../contract/generated/bff/src/models";

interface SearchResultsListProps {
  results: ISearchResultDto[];
}

export const SearchResultsList: React.FC<SearchResultsListProps> = ({
  results,
}) => (
  <Box data-id="search-results-list">
    {results.map((result) => (
      <SearchResultItem key={result.url} result={result} />
    ))}
  </Box>
);
